import api from '../utils/api';

export async function listAgentAnalysisReports({
  page = 1,
  perPage = 20,
  agentId = null,
  periodKey = null,
} = {}) {
  const params = { page, per_page: perPage };
  if (agentId) params.agent_id = agentId;
  if (periodKey) params.period_key = periodKey;

  const { data } = await api.get('/analysis-reports/', { params });
  return data;
}

export async function getAgentAnalysisReport(id) {
  const { data } = await api.get(`/analysis-reports/${id}`);
  return data;
}
